module.exports = __webpack_public_path__ + "img/score-empty.4bd76d6b.png";